/** Reduced-precision ISO dates: null means unknown; YYYY never implies Jan 1. */
export function isYearOnlyInstallDate(value: string): boolean {
 return /^[1-9]\d{3}$/.test(value);
}
export function isEquipmentInstallDate(value: string): boolean {
 if (isYearOnlyInstallDate(value)) return true;
 if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
 const date = new Date(`${value}T00:00:00Z`);
 return Number.isFinite(date.getTime()) && date.toISOString().slice(0,10) === value;
}
export function equipmentInstallDateLabel(value: string | null): string {
 if (!value) return 'Unknown';
 if (isYearOnlyInstallDate(value)) return `${value} (year only)`;
 if (!isEquipmentInstallDate(value)) return 'Unknown';
 return new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',year:'numeric',timeZone:'UTC'}).format(new Date(`${value}T00:00:00Z`));
}
